function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
function shopifyGidToNumericId(gid) {
  if (gid == null || gid === "") return "";
  var s = String(gid);
  var m = s.match(/\/(\d+)\s*$/);
  return m ? m[1] : s;
}
function parseOaceDiscountCollectionScope(discount) {
  if (!discount || !discount.customerGets) return null;
  var items = discount.customerGets.items;
  if (!items || typeof items !== "object") return null;
  if (items.__typename === "AllDiscountItems" && items.allItems === true)
    return null;
  var collections = items.collections;
  if (!collections || typeof collections !== "object") {
    if (items.__typename === "DiscountCollections") return [];
    return null;
  }
  var ids = [];
  var nodes = collections.nodes;
  if (Array.isArray(nodes)) {
    nodes.forEach(function (node) {
      var nid = shopifyGidToNumericId(node && node.id);
      if (nid) ids.push(nid);
    });
  }
  if (ids.length > 0) {
    var seen = {};
    return ids.filter(function (id) {
      if (seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }
  if (items.__typename === "DiscountCollections") return [];
  return null;
}
function priceListMatchesOaceDiscountScope(priceContainer) {
  if (currentDiscountCollectionIds == null) return true;
  if (
    !Array.isArray(currentDiscountCollectionIds) ||
    currentDiscountCollectionIds.length === 0
  )
    return false;
  var raw = priceContainer.dataset && priceContainer.dataset.productCollections;
  if (raw == null || String(raw).trim() === "") return false;
  var productCols = String(raw)
    .split(",")
    .map(function (s) {
      return s.trim();
    })
    .filter(Boolean);
  var set = currentDiscountCollectionIds;
  return productCols.some(function (id) {
    return set.indexOf(id) !== -1;
  });
}
function setcookie(cookieName, cookieValue, expires = 14) {
  var today = new Date();
  if (expires == 0) {
    var expire = 0;
  } else {
    var expire = new Date();
    expire.setTime(today.getTime() + 3600000 * 24 * expires);
    expire = expire.toGMTString();
  }
  document.cookie =
    cookieName + "=" + encodeURI(cookieValue) + ";path=/;expires=" + expire;
}
async function checkDiscountCode(code, forAnalyzeCart = false) {
  console.log("DEBUG checkDiscountCode:start", {
    code: code,
    forAnalyzeCart: forAnalyzeCart,
  });
  if (forAnalyzeCart) {
    const cartJSON = await (
      await fetch(`${Shopify.routes.root}cart.js`)
    ).json();
    var list = cartJSON.discount_codes || [];
    console.log("DEBUG checkDiscountCode:cart.discount_codes", list);
    if (list.length > 0) {
      var last = list[list.length - 1];
      var applied = decodeURI(last.code).trim().toUpperCase();
      setcookie("discount_code", applied);
      document.dispatchEvent(new CustomEvent("discount:changed"));
      console.log("DEBUG checkDiscountCode:return (from cart)", applied);
      return applied;
    }
    deleteCookie("discount_code");
    console.log("DEBUG checkDiscountCode:return false (no cart discount)");
    return false;
  }
  var resolved =
    typeof code !== "undefined" && code !== null ? String(code).trim() : "";
  if (!resolved) return false;
  return resolved.toUpperCase();
}
async function validateOaceDiscountCode(code) {
  console.log("DEBUG validateOaceDiscountCode:start", code);
  var base =
    typeof window.oaceDiscountApiBase === "string"
      ? window.oaceDiscountApiBase.trim()
      : "";
  if (!base || !code) {
    console.log("DEBUG validateOaceDiscountCode:skip (no base or code)");
    return false;
  }
  var normalizedBase = base.replace(/\/+$/, "");
  var pathCode = encodeURIComponent(String(code).trim());
  var url = normalizedBase + "/oace-discount/discount/" + pathCode;
  try {
    var res = await fetch(url, {
      method: "GET",
      headers: { Accept: "application/json" },
    });
    console.log("DEBUG validateOaceDiscountCode:status", res.status);
    if (!res.ok) return false;
    var body = await res.json();
    var edges =
      body &&
      body.data &&
      body.data.discountNodes &&
      body.data.discountNodes.edges;
    var valid = !!(edges && edges.length > 0);
    console.log("DEBUG validateOaceDiscountCode:valid", valid);
    return valid;
  } catch (e) {
    console.log("DEBUG validateOaceDiscountCode:error", e);
    return false;
  }
}
async function loadDiscountPercentageFromOaceApi(discountCode) {
  console.log("DEBUG loadDiscountPercentageFromOaceApi:start", discountCode);
  if (window.oaceDiscountCheckDisabled) {
    console.log("DEBUG loadDiscountPercentageFromOaceApi:disabled by setting");
    return false;
  }
  var base =
    typeof window.oaceDiscountApiBase === "string"
      ? window.oaceDiscountApiBase.trim()
      : "";
  if (!base || !discountCode) {
    console.log(
      "DEBUG loadDiscountPercentageFromOaceApi:skip (no base or code)",
      { base: base, discountCode: discountCode }
    );
    return false;
  }
  var normalizedBase = base.replace(/\/+$/, "");
  var pathCode = encodeURIComponent(String(discountCode).trim());
  var url = normalizedBase + "/oace-discount/discount/" + pathCode;
  console.log("DEBUG loadDiscountPercentageFromOaceApi:fetch", url);
  try {
    var res = await fetch(url, {
      method: "GET",
      headers: { Accept: "application/json" },
    });
    console.log("DEBUG loadDiscountPercentageFromOaceApi:status", res.status);
    if (!res.ok) return false;
    var body = await res.json();
    console.log("DEBUG loadDiscountPercentageFromOaceApi:body", body);
    var edges =
      body &&
      body.data &&
      body.data.discountNodes &&
      body.data.discountNodes.edges;
    if (!edges || edges.length === 0) {
      console.log("DEBUG loadDiscountPercentageFromOaceApi:no edges");
      return false;
    }
    var discount = edges[0] && edges[0].node && edges[0].node.discount;
    var value =
      discount && discount.customerGets && discount.customerGets.value;
    console.log("DEBUG loadDiscountPercentageFromOaceApi:value", value);
    if (!value || typeof value !== "object") return false;
    if (
      typeof value.percentage !== "number" ||
      !Number.isFinite(value.percentage)
    ) {
      console.log(
        "DEBUG loadDiscountPercentageFromOaceApi:skip non-percentage value"
      );
      return false;
    }
    var collectionIds = parseOaceDiscountCollectionScope(discount);
    console.log("DEBUG loadDiscountPercentageFromOaceApi:return", {
      percentage: value.percentage,
      collectionIds: collectionIds,
    });
    return { percentage: value.percentage, collectionIds: collectionIds };
  } catch (e) {
    console.log("DEBUG loadDiscountPercentageFromOaceApi:error", e);
    return false;
  }
}
function refreshCart() {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );
}
function getCurrentRedirect() {
  var currentURL = window.location.href;
  var uselessURL = window.location.protocol + "//" + window.location.hostname;
  var currentRedirect = currentURL.replace(uselessURL, "");
  return currentRedirect;
}
function updateSaleBadge(priceContainer, final_price, original_price) {
  let productWrapper = priceContainer;
  let maxLoop = 10;
  do {
    productWrapper = productWrapper.parentElement;
    maxLoop--;
  } while (
    productWrapper &&
    productWrapper.tagName != "PRODUCT-CARD" &&
    !productWrapper.classList.contains("product-info__price") &&
    maxLoop > 1
  );

  if (productWrapper && maxLoop > 0) {
    let discountSaleBadge = productWrapper.querySelector(
      "on-sale-badge.discount-badge"
    );
    if (
      discountSaleBadge &&
      !discountSaleBadge.parentElement.classList.contains("crawled")
    ) {
      let newPercentage =
        Math.round(((original_price - final_price) / original_price) * 100) + "%";
      // console.log('updateSaleBadge ', priceContainer, final_price, original_price, newPercentage)
      discountSaleBadge.querySelector("span").innerText =
        window.themeVariables.strings.discount_badge.replace(
          "[]",
          newPercentage
        );
      discountSaleBadge.parentElement.classList.add("crawled");
    }
    let discountText = productWrapper.querySelector(
      ".discount-badge.discount-text"
    );
    // console.log("discountText ", discountText, productWrapper)
    if (discountText && extraGlobalDiscount) {
      let newPrice = final_price * (1 - extraGlobalDiscount / 100);
      let newPercentage2 = parseInt(
        ((original_price - newPrice) / original_price) * 100
      );
      discountText.innerText =
        window.themeVariables.strings.discount_text.replace(
          "[]",
          newPercentage2
        );
      discountText.parentElement.classList.add("crawled");
    }
  }
}

function updateDiscountTextBadge() {
  let priceLists = document.querySelectorAll("price-list");
  priceLists.forEach(function (priceContainer) {
    let salePrice = priceContainer.dataset.salePrice,
      comparePrice = priceContainer.dataset.comparePrice,
      original_price = comparePrice;
    if (
      parseInt(comparePrice) == 0 ||
      comparePrice == "" ||
      comparePrice == "null"
    ) {
      original_price = salePrice;
    }

    let productWrapper = priceContainer;
    let maxLoop = 10;
    do {
      productWrapper = productWrapper.parentElement;
      maxLoop--;
    } while (productWrapper && productWrapper.tagName != "PRODUCT-CARD" && !productWrapper.classList.contains("product-info__price") && maxLoop > 1);

    if (productWrapper && maxLoop > 0) {
      let discountText = productWrapper.querySelector(
        ".discount-badge.discount-text"
      );
      // console.log("discountText ", discountText, productWrapper)
      if (
        discountText &&
        extraGlobalDiscount &&
        !discountText.classList.contains("crawled")
      ) {
        let newPrice = salePrice * (1 - extraGlobalDiscount / 100);
        let newPercentage2 = parseInt(
          ((original_price - newPrice) / original_price) * 100
        );
        discountText.innerText =
          window.themeVariables.strings.discount_text.replace(
            "[]",
            newPercentage2
          );
        discountText.classList.add("crawled");
      }
    }
  });
}
async function calculateDiscounts() {
  if (window.oaceDiscountCheckDisabled) {
    console.log("DEBUG calculateDiscounts:disabled by setting");
    let crawledItems = document.querySelectorAll(".crawled:not(.const)");
    crawledItems.forEach((item) => {
      item.classList.remove("crawled");
    });
    return;
  }
  var checkCode = await checkDiscountCode("", true);
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled
    ? window.themeVariables.settings.moneyWithCurrencyFormat
    : window.themeVariables.settings.moneyFormat;
  console.log("DEBUG calculateDiscounts:start", {
    code: checkCode,
    percentage: currentDiscountPercentage,
    collectionScope: currentDiscountCollectionIds,
  });
  if (
    checkCode &&
    typeof currentDiscountPercentage === "number" &&
    currentDiscountPercentage > 0
  ) {
    document.dispatchEvent(new CustomEvent("update-bundle-price"));
    let priceLists = document.querySelectorAll("price-list");
    console.log("DEBUG calculateDiscounts:applying", {
      percentage: currentDiscountPercentage,
      priceLists: priceLists.length,
    });
    priceLists.forEach(function (priceContainer) {
      if (!priceListMatchesOaceDiscountScope(priceContainer)) return;
      if (!priceContainer.classList.contains("crawled")) {
        let salePrice = priceContainer.dataset.salePrice,
          comparePrice = priceContainer.dataset.comparePrice,
          startFromText = priceContainer.dataset.priceMin;
        if (salePrice && salePrice > 0) {
          let newSalePrice = salePrice * (1 - currentDiscountPercentage);
          console.log("DEBUG calculateDiscounts:item", {
            salePrice: salePrice,
            newSalePrice: newSalePrice,
          });
          priceContainer.querySelector(
            ".discount-content sale-price"
          ).innerText =
            startFromText + formatMoney(newSalePrice, currencyFormat);
          if (
            !priceContainer
              .querySelector(".discount-content sale-price")
              .classList.contains("text-on-sale")
          ) {
            priceContainer
              .querySelector(".discount-content sale-price")
              .classList.add("text-on-sale");
          }
          let original_price = comparePrice;
          if (
            parseInt(comparePrice) == 0 ||
            comparePrice == "" ||
            comparePrice == "null"
          ) {
            if (
              priceContainer.querySelector(".discount-content compare-at-price")
            ) {
              priceContainer.querySelector(
                ".discount-content compare-at-price"
              ).innerText = formatMoney(salePrice, currencyFormat);
              priceContainer
                .querySelector(".discount-content compare-at-price")
                .removeAttribute("hidden");
            } else {
              let compareItem = document.createElement("compare-at-price");
              compareItem.className = "text-subdued line-through";
              compareItem.innerText = formatMoney(salePrice, currencyFormat);
              priceContainer
                .querySelector(".discount-content")
                .appendChild(compareItem);
            }
            original_price = salePrice;
          }
          updateSaleBadge(priceContainer, newSalePrice, original_price);
          priceContainer.classList.add("crawled");
        }
      }
    });
  } else {
    let crawledItems = document.querySelectorAll(".crawled:not(.const)");
    console.log("DEBUG calculateDiscounts:reset", {
      reason: !checkCode ? "no code" : "no percentage",
      cleared: crawledItems.length,
    });
    crawledItems.forEach((item) => {
      item.classList.remove("crawled");
    });
  }
}
async function updateItem(item, type) {
  // console.log("updateItem")
  let requestBody = JSON.stringify(item);
  let requestMethod = requestBody.includes("updates") ? "update" : "change";
  await fetch(window.Shopify.routes.root + "cart/" + requestMethod + ".js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: requestBody,
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
    })
    .then((data) => {
      // if (type == 'sys') { updateCartContent("sidebar"); }
      refreshCart();
    })
    .catch((error) => {
      failCart(requestMethod);
    })
    .finally(() => {
      // $(".dgs-cartbar-item[loading='delete']").remove();
      // $("*[loadercover]").removeAttr("loadercover").prop("disabled", false);
    });
}

async function analyzeCart(cartJSON, reload = false, mutation = false) {
  console.log("DEBUG analyzeCart:start");
  currentDiscountPercentage = false;
  currentDiscountCollectionIds = null;
  // Cookie/cart sync runs even when the discount check is disabled, so the
  // field can show the code currently applied to the cart; only the price
  // analysis below is skipped.
  var currentCode = await checkDiscountCode("", true);
  console.log("DEBUG analyzeCart:currentCode", currentCode);
  if (window.oaceDiscountCheckDisabled) {
    console.log("DEBUG analyzeCart:disabled by setting (code synced)");
    refreshCart();
    return false;
  }
  cartJSON = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

  if (!cartJSON) {
    console.log("DEBUG analyzeCart:abort (no cart.js response)");
    return false;
  }

  if (currentCode) {
    var apiDiscount = await loadDiscountPercentageFromOaceApi(currentCode);
    if (
      apiDiscount &&
      typeof apiDiscount.percentage === "number" &&
      apiDiscount.percentage > 0
    ) {
      currentDiscountPercentage = apiDiscount.percentage;
      currentDiscountCollectionIds = apiDiscount.collectionIds;
      console.log("DEBUG analyzeCart:discount applied", {
        percentage: currentDiscountPercentage,
        collectionIds: currentDiscountCollectionIds,
      });
    } else {
      console.log("DEBUG analyzeCart:no usable percentage");
    }
  }
  refreshCart();
  await calculateDiscounts();
  console.log("DEBUG analyzeCart:done", {
    code: currentCode,
    percentage: currentDiscountPercentage,
  });
}

function openNotification(msg = "", type = "success") {
  let cartOpen = document.querySelector("cart-drawer[open]") ? true : false,
    notibar = document.querySelector(".tantee-notificaiton-bar");
  var notiClose = 4500;
  if (msg != "" && notibar && notibar.getAttribute("open") != "true") {
    if (!cartOpen) {
      notibar.setAttribute("msg-type", type);
      notibar.innerHTML = msg;
      notibar.setAttribute("open", "true");
      if (notibarTimeout) {
        clearTimeout(notibarTimeout);
      }
      notibarTimeout = setTimeout(function () {
        notibar.setAttribute("open", "false");
      }, notiClose);
    }
  }
}

function notifyDiscount() {
  var discount_code = getCookie("discount_code");
  //console.log("discount_code",discount_code);
  if (discount_code) {
    var sessionStorage_code = sessionStorage.getItem("lastDiscountCode");
    //console.log("sessionStorage_code",sessionStorage_code);
    var decodedCode = decodeURI(discount_code.trim());
    var checkCode = decodedCode.toUpperCase();
    if (sessionStorage_code === null || checkCode != sessionStorage_code) {
      let discountMsg = document
        .querySelector(".tantee-notificaiton-bar")
        .getAttribute("data-discount-text");
      var codeSuccessNotiMsg = discountMsg.replace(
        "[]",
        "<b>" + checkCode + "</b>"
      );
      openNotification(codeSuccessNotiMsg, "success");
      sessionStorage.setItem("lastDiscountCode", checkCode);
    }
  }
}

async function go2checkout(skipGift = false) {
  if (
    !skipGift &&
    document.querySelector(".gamification") &&
    document.querySelector(".gamification").dataset.status == "all_granted" &&
    document.querySelector(".gamification").dataset.incart == "false"
  ) {
    if (document.querySelector('button[aria-controls="gift-leave"]')) {
      document.querySelector('button[aria-controls="gift-leave"]').click();
    }
  } else {
    window.location = "/checkout";
  }
}
